export enum ChargeFlowActionType {
    mobile_app_confirmation = 'mobile_app_confirmation',
    app_redirect = 'app_redirect',
    qr_code = 'qr_code',
    redirect = 'redirect',
    wait = 'wait',
    none = 'none',
}